import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'backslash', 'IconBackslash', [["path",{"d":"M7 5l10 14","key":"svg-0"}]]);